import { render } from "./AddSub.vue?vue&type=template&id=29b1ae3a"
import script from "./AddSub.vue?vue&type=script&lang=js"
export * from "./AddSub.vue?vue&type=script&lang=js"

import exportComponent from "/home/marco/keyos-projects/esamiFinanza/webapp-esamifinanza/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__